import { validatePhoneNumber } from "~/services/utility"

const buildNameValidation = (requiredMessage, notEnoughCharactersMessage) => value => {
  const valueLength = value.trim().length

  if (!valueLength) return requiredMessage
  if (valueLength < 2) return notEnoughCharactersMessage

  return false
}

export const FETCHER_VALIDATIONS = {
  firstName: buildNameValidation(
    "First name is required.",
    "First name should be at least two characters long."
  ),
  lastName: buildNameValidation(
    "Last name is required.",
    "Last name should be at least two characters long."
  )
}

export const FETCHER_ASYNC_VALIDATIONS = {
  phoneNumber: async (phoneNumber) => {
    const errorMessage = 'Only US phone numbers are allowed.'
    
    try {
      const { valid } = await validatePhoneNumber(phoneNumber)

      return valid ? false : errorMessage
    } catch (error) {
      return errorMessage
    }
  }
}
